<template>
  <div>
    <custom-callout
      v-if="isPendingOrder"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2"
      :border-color="getStudentBookStatusColor(value.statusId)"
      @click:open="toggleAdditionalInfo()"
    >
      <ValidationObserver ref="documentBookOrder">
        <div class="row mt-2 pb-3">
          <div
            :class="[
              'col-md-2',
              { 'pt-3': !isMobile, 'col-8 pl-2 pt-2': isMobile },
            ]"
          >
            <custom-balloon
              class="px-3"
              :text="value.status"
              :background-color="getStudentBookStatusColor(value.statusId)"
            />
          </div>
          <div class="col-md-10 pt-3">
            <div class="row">
              <div class="col-md-4 col-sm-12 col-6">
                <div class="info-text-title">
                  Título
                </div>
                <p class="info-text">
                  {{ value.title }}
                </p>
              </div>
              <div class="col-md-3 col-6">
                <div class="info-text-title">
                  Materia:
                </div>
                <p class="info-text">
                  {{ value.subject }}
                </p>
              </div>
              <div class="col-md-2 col-12">
                <div class="info-text-title">
                  Grado:
                </div>
                <p class="info-text">
                  {{ value.grade }}
                </p>
              </div>
              <div
                :class="[
                  'col-md-2 col-sm-12 buttons-full',
                  { 'ml-5 pl-4': !isMobile },
                ]"
              >
                <ActionButton
                  class="mr-2 btn-transparent float-right"
                  variant="outline-success"
                  i="fas fa-save mx-auto"
                  @click="document"
                />
                <ActionButton
                  v-if="showRemoveButton"
                  class="mr-2 btn-transparent float-right"
                  variant="outline-danger"
                  i="fas fa-times-circle mx-auto"
                  @click="remove"
                />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4 col-6">
                <div class="info-text-title">
                  Medio de Lectura
                  <br />
                  (Braile, Letra Agrandada, Audio):
                </div>
                <div
                  class="align-items-end d-flex p-0 pt-2 custom-radio-container"
                >
                  <ValidationProvider rules="required">
                    <CustomRadio
                      ref="medio"
                      :name="`medio_${value.bookId}`"
                      :is-disabled="false"
                      :custom-error-msg="resources['180008'] || null"
                      :change-event="onChangeMedio"
                      :options="optionsReadingMedium"
                      :is-question-list="true"
                      :error="!medioSelected"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="info-text-title">
                  Pedido:
                  <br />
                  <br />
                </div>
                <div
                  :class="{ 'pt-4': isMobile }"
                  class="align-items-start d-flex p-0 pt-2 custom-radio-container"
                >
                  <ValidationProvider rules="required">
                    <CustomRadio
                      :name="`pedido_${value.bookId}`"
                      :custom-error-msg="resources['180009'] || null"
                      :change-event="onChangePedido"
                      :options="optionsYesNoList"
                      :is-question-list="true"
                      :error="!pedidoSelected"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div
                v-if="showRequestReason"
                :class="['col-md-5 col-sm-12 col-12', { 'pt-3': isMobile }]"
              >
                <div class="info-text-title">
                  Razón:
                </div>
                <br v-show="!isMobile" />
                <div :class="['px-0 col-12 col-md-11 pt-2 pr-2']">
                  <ValidationProvider rules="required">
                    <custom-drop-down
                      v-model="value.requestReason"
                      :name="`razon_${value.bookId}`"
                      fieldkey="id"
                      fieldname="value"
                      :clearable="false"
                      :options="requestReasonOptions"
                      placeholder="Seleccione"
                      :error="!reasonSelected ? resources['180100'] : null"
                      :custom-error-msg="resources['180100'] || null"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div v-if="showAvailableAlert" class="row mt-2">
              <div class="col-12">
                <Error
                  :message="availableBookMsg"
                  is-alert-mode
                  class="w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
      <div
        :class="[
          'row mt-2 buttons-mobile',
          { 'pt-2 mb-3': isMobile, 'pl-4': !isMobile },
        ]"
      >
        <div class="col" :class="{ 'pr-0': isMobile }">
          <ActionButton
            v-if="showRemoveButton"
            class="mr-2 btn-transparent lg-btn"
            variant="outline-danger"
            text="Remover"
            i="fas fa-times-circle mx-auto"
            @click="remove"
          />
        </div>
        <div class="col mr-2" :class="{ 'pl-1': isMobile }">
          <ActionButton
            class="mr-2 lg-btn"
            variant="success"
            text="Guardar"
            i="fas fa-save mx-auto"
            @click="document"
          />
        </div>
      </div>
    </custom-callout>
    <custom-callout
      v-else
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2"
      :border-color="getStudentBookStatusColor(value.statusId)"
      @click:open="toggleAdditionalInfo()"
    >
      <div class="row mt-2 pb-3">
        <div
          :class="[
            'col-md-2',
            { 'pt-3': !isMobile, 'col-8 pl-2 pt-2': isMobile },
          ]"
        >
          <custom-balloon
            class="px-3"
            :text="value.status"
            :background-color="getStudentBookStatusColor(value.statusId)"
          />
        </div>
        <div class="col-md-10 pt-3">
          <div class="row">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Título:
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div
              class="col-6"
              :class="{
                'col-md-3': hasBooksPendingOrder,
                'col-md-4': !hasBooksPendingOrder,
              }"
            >
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div
              class="col-6"
              :class="{
                'col-md-2': hasBooksPendingOrder,
                'col-md-4': !hasBooksPendingOrder,
              }"
            >
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Medio de Lectura:
              </div>
              <p class="info-text">
                {{ value.readingMedium }}
              </p>
            </div>
            <div
              class="col-md-3 col-6"
              :class="{
                'col-md-3': hasBooksPendingOrder,
                'col-md-4': !hasBooksPendingOrder,
              }"
            >
              <div class="info-text-title">
                Pedido:
              </div>
              <p class="info-text">
                {{ value.requested ? 'Sí' : 'No' }}
              </p>
            </div>
            <div
              v-show="value.requested"
              class="col-6"
              :class="{
                'col-md-2': hasBooksPendingOrder,
                'col-md-4': !hasBooksPendingOrder,
              }"
            >
              <div class="info-text-title">
                Razón:
              </div>
              <p class="info-text">
                {{ value.requestReason && value.requestReason.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <a
      :ref="`ei-collapse-${value.bookId}`"
      class="hidden"
      data-toggle="collapse"
      :href="`#ei-collapse-${value.bookId}`"
      aria-expanded="false"
      :aria-controls="`ei-collapse-${value.bookId}`"
    />
    <div :id="`ei-collapse-${value.bookId}`" class="collapse">
      <div class="bg-gray p-2">
        <div class="bg-white rounded p-3">
          <b-tabs
            content-class="mt-3"
            :no-nav-style="true"
            nav-class="nav-vue-underline"
          >
            <b-tab title="Información Adicional">
              <BookInfo :book="value" />
            </b-tab>
            <b-tab lazy title="Historial de Pedido">
              <History :book="value" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from 'custom-error';
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import readingMediumOptions from '@/utils/constants/book/readingMediumOptions';
import requestReasonOptions from '@/utils/constants/book/requestReasonOptions';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { BookInfo, History } from '@/views/books/commons/tabs';
import {
  studentBookStatus,
  studentBookStatusString,
  getStudentBookStatusColor,
} from '@/utils/constants/book/studentBookStatus';
import {
  removeOrder,
  documentBookOrder,
  getBookAvailability,
} from '@/modules/books-requests/api';

export default {
  name: 'OrderBookResultRow',
  mixins: [mixAlert],
  components: {
    CustomCallout,
    CustomBalloon,
    BookInfo,
    History,
    ActionButton,
    CustomRadio,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
    Error,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    hasBooksPendingOrder: {
      type: Boolean,
      required: true,
    },
    resources: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      getStudentBookStatusColor,
      isOpen: false,
      optionsYesNoList: null,
      filters: {
        selectedMedio: null,
        selectedPedido: null,
      },
      medioSelected: true,
      pedidoSelected: true,
      reasonSelected: true,
      optionsReadingMedium: null,
      showAvailableAlert: false,
      availableBookMsg:
        'Libro disponible por las entregas del año académico anterior: "Según los criterios solicitados, la escuela cuenta con el libro disponible del año académico anterior".',
    };
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    isPendingOrder() {
      return this.value.status == studentBookStatusString.PendientePedido;
    },
    requestReasonOptions() {
      return requestReasonOptions;
    },
    showRemoveButton() {
      return this.value.statusId == studentBookStatus.PendientePedido;
    },
    showRequestReason() {
      return this.value.requested;
    },
  },
  methods: {
    toggleAdditionalInfo() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);
      link.click();
      this.isOpen = !isOpen;
    },
    getCollapse() {
      let link = this.$refs[`ei-collapse-${this.value.bookId}`];
      const isOpen = link.getAttribute('aria-expanded') == 'true';
      return { link, isOpen };
    },
    close() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);

      if (isOpen) {
        this.isOpen = false;
        link.click();
      }
    },
    async remove() {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover el pedido del libro "${this.value.title}"?`,
        'Sí',
        'No'
      );

      if (!confirm) {
        return;
      }

      await removeOrder(this.value)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'El libro ha sido removido de mi lista de seleccionados exitosamente.',
              'success'
            );
            this.$emit('afterRemoved');
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    onChangeMedio(item) {
      this.medioSelected = true;
      this.value.readingMediumCode = item.id;
    },
    async onChangePedido(item) {
      this.pedidoSelected = true;

      if (this.value.requested == item.id) return;
      this.value.requested = item.id;

      if (this.value.requested) {
        const { data } = await getBookAvailability(
          this.value.bookId,
          this.value.academicYearId
        );
        this.showAvailableAlert = data;
      } else {
        this.showAvailableAlert = false;
      }
    },
    async document() {
      let isValid =
        this.$refs.documentBookOrder.validate() && this.validateRadios();

      if (!isValid) {
        this.ShowToast('Error', 'Información Incompleta.', 'error');
        return;
      }

      this.value.requestReasonCode = this.value.requested
        ? this.value.requestReason?.id
        : null;
      await documentBookOrder(this.value)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'El pedido del libro ha sido documentado exitosamente.',
              'success'
            );
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    validateRadios() {
      this.medioSelected = this.optionsReadingMedium.some(
        (e) => e.check == true
      );
      this.pedidoSelected = this.optionsYesNoList.some((e) => e.check == true);
      this.reasonSelected =
        !this.value.requested ||
        (this.value.requested && this.value.requestReason);

      return this.medioSelected && this.pedidoSelected && this.reasonSelected;
    },
    validateBeforeSubmit() {
      return this.$refs.documentBookOrder.validate() && this.validateRadios();
    },
  },
  created() {
    this.optionsReadingMedium = readingMediumOptions.map((a) => ({
      id: a.id,
      label: a.text,
      invalid: false,
      disabled: false,
      check: a.id == this.value.readingMediumCode,
    }));

    this.optionsYesNoList = [
      {
        id: true,
        name: 'question1',
        label: 'Sí',
        check: this.value.requested,
        invalid: false,
        disabled: false,
      },
      {
        id: false,
        name: 'question2',
        label: 'No',
        check: this.value.readingMediumCode && !this.value.requested,
        invalid: false,
        disabled: false,
      },
    ];
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';
.mrc {
  margin-left: 30px;
}

.orange-icon {
  color: #ff7058;
}
.btn-transparent:not(:hover) {
  background: transparent !important;
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
  align-items: unset !important;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
  background-color: #e2e2e2 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.buttons-mobile {
  display: none;
}

.balloon-container.px-3.cream {
  background-color: #fce0c8 !important;
}

@media only screen and (max-width: 375px) {
  .selct-text {
    display: none;
  }

  .fa-check {
    margin-right: 0px !important;
  }

  .buttons-mobile {
    display: flex;
  }

  .lg-btn {
    width: 100%;
  }

  .buttons-full {
    display: none;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 12px !important;
  }

  ::v-deep .balloon-container {
    font-size: 12px !important;
  }
}

::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

::v-deep .bg-gray {
  background-color: #e2e2e2 !important;
}

::v-deep .bg-green {
  background-color: #2db782 !important;
  border-color: #2db782;
}

::v-deep .radio .cr {
  border: 2px solid #ffffff !important;
}

::v-deep .step-label {
  color: #ffffff !important;
}

::v-deep .step-label-mobile {
  color: #ffffff !important;
}

::v-deep .balloon-container {
  font-size: 16px;
}

::v-deep .balloon-container.green-light {
  background-color: $green_light !important;
}
</style>
